import React from 'react';
import { Card, Upload, Button, List, Typography, message } from 'antd';
import { FileExcelOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

const { Dragger } = Upload;

const ExcelUploadTab = ({ fileList, onFileChange, onFileRemove }) => {
  const uploadProps = {
    name: 'file',
    multiple: false,
    maxCount: 1,
    fileList,
    accept: '.xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
    beforeUpload: (file) => {
      const name = (file.name || '').toLowerCase();
      const ok =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel' ||
        name.endsWith('.xlsx') ||
        name.endsWith('.xls');
      if (!ok) {
        message.error('Please upload an Excel file (.xlsx or .xls).');
        return false;
      }
      const isLt15M = file.size / 1024 / 1024 < 15;
      if (!isLt15M) {
        message.error('File must be smaller than 15MB.');
        return false;
      }
      onFileChange(file);
      return false;
    },
    onRemove: onFileRemove,
  };

  return (
    <Card title="Import from Excel" style={{ marginBottom: 16 }}>
      <Paragraph type="secondary" style={{ marginBottom: 12 }}>
        No AI is used. The first sheet is read; row 1 must be column headers. Required: at least{' '}
        <Text strong>ISBN</Text> or <Text strong>Title</Text> per line. Typical headers: ISBN, Title,
        Author, Publisher, Price, Qty. Optional: Discount, Currency, Supplier name, Bill date, Bill
        number.
      </Paragraph>
      <Dragger {...uploadProps} style={{ marginBottom: 16 }}>
        <p className="ant-upload-drag-icon">
          <FileExcelOutlined />
        </p>
        <p className="ant-upload-text">Click or drag an Excel file here</p>
        <p className="ant-upload-hint">.xlsx or .xls, max 15MB. One file per import.</p>
      </Dragger>

      {fileList.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <Text strong>Selected file:</Text>
          <List
            size="small"
            dataSource={fileList}
            renderItem={(file) => (
              <List.Item
                actions={[
                  <Button
                    key="remove"
                    type="link"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => onFileRemove(file)}
                  >
                    Remove
                  </Button>,
                ]}
              >
                <Text>{file.name}</Text>
              </List.Item>
            )}
          />
        </div>
      )}
    </Card>
  );
};

export default ExcelUploadTab;
